import DeleteIcon from '@mui/icons-material/DeleteOutline';
import { Box, Button, Grid, Typography } from '@mui/material';

interface SubstanceStudyCardProps {
    name: string;
    surname: string;
    permission: string;
    licenseNumber: string;
    expeditionDate: string;
    type: string;
    cuit: string;
    expirationDate: string;
    otherData: string;
    handleDeleteClick: any;
    translate: (key: string) => string;
    onlyVisual?: boolean;
}

const ResponsibleCard = ({
    name,
    surname,
    permission,
    licenseNumber,
    type,
    cuit,
    handleDeleteClick,
    expeditionDate,
    expirationDate,
    otherData,
    translate,
    onlyVisual = false
}: SubstanceStudyCardProps) => (
    <Box
        sx={{
            backgroundColor: '#F3F8F8',
            borderRadius: '8px',
            padding: '16px'
        }}
    >
        <Grid container justifyContent={'space-between'} alignItems={'flex-start'}>
            <Typography variant="subtitle1">{`${name || '-'} ${
                surname || ''
            } - ${cuit}`}</Typography>
            {!onlyVisual && (
                <Button
                    variant="outlined"
                    sx={{
                        minWidth: 32,
                        minHeight: 32,
                        padding: 0,
                        borderRadius: 1,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        color: '#D32F2F',
                        borderColor: '#D32F2F',
                        '&:hover': {
                            backgroundColor: 'transparent'
                        }
                    }}
                    onClick={handleDeleteClick}
                >
                    <DeleteIcon sx={{ fontSize: 18 }} />
                </Button>
            )}
        </Grid>
        <Typography variant="body1">{`${translate('responsableCard.permission')}: ${
            permission || '-'
        } - ${translate('responsableCard.licenseNumber')}: ${licenseNumber || '-'}`}</Typography>
        <Typography variant="body1">{`${translate('responsableCard.expeditionDate')}: ${
            expeditionDate || '-'
        } - ${translate('responsableCard.expirationDate')}: ${expirationDate || '-'}`}</Typography>
        <Typography variant="body1">{`${translate('responsableCard.type')}: ${
            type || '-'
        }`}</Typography>
        <Typography variant="body1">{`${translate('responsableCard.otherData')}: ${
            otherData || '-'
        }`}</Typography>
    </Box>
);

export { ResponsibleCard };
